import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { BrandService } from '../../core/brand.service';

interface HeaderCta {
  label: string;
  link: string;
}

@Component({
  selector: 'app-auth-header',
  imports: [RouterLink],
  templateUrl: './auth-header.component.html',
  styleUrl: './auth-header.component.scss',
})
export class AuthHeaderComponent {
  private readonly router = inject(Router);
  private readonly brand = inject(BrandService);

  public readonly brandProfile = this.brand.brand;
  public readonly cta = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => this.resolveCta(event.urlAfterRedirects)),
      startWith(this.resolveCta(this.router.url))
    ),
    { initialValue: this.resolveCta(this.router.url) }
  );

  private resolveCta(url: string): HeaderCta | null {
    if (url.startsWith('/login')) {
      return { label: 'Regístrate', link: '/register' };
    }
    if (url.startsWith('/register') || url.startsWith('/recovery') || url.startsWith('/seleccionar-portal')) {
      return { label: 'Iniciar sesión', link: '/login' };
    }
    return null;
  }
}
